import createStartMarker from './explorer/createStartMarker';

const startMarker = createStartMarker()({feature: null});

export default startMarker;
